import React, {Component} from 'react';
import './css/publisher.css';
import './css/styles.css';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
class Publishers extends React.Component{
    render(){
        return(   
            <div>
                <Helmet>
                <title>{this.props.value.title}</title>
                <meta
                    property="og:title"
                    content={this.props.value.title}
                />

                <meta
                    property="og:description"
                    content={this.props.value.description}
                />
                  <meta
                    property="og:url"
                    content={window.location.href}
                />
                <link rel="canonical" href={window.location.href} />
                <link rel="alternate" hreflang="en-in" href={window.location.href} />

            </Helmet>
             <div style={{position: 'relative',paddingTop:'80px'}}>
                <img src="/assets/images/aiplex-ads-publishers.png" alt="publilsher"  title="publilsher" className="landing_img"/>
                <div className="landing_text">
                    <h1 className="corporate ltext">
                        <span className="first-letter">P</span>UBLISHER
                    </h1>
                </div>
                <div className="bcdiv">
          <div className=" row">
          <td className="bchome">
          <a href="/" className="pl-1 bchome">Home</a>
          </td>
          <i className="bctext fa fa-angle-double-right pl-2" aria-hidden="true"></i>
          <td className="bcblue">
          <a href="/publishers" className="pl-2 bcblue">Publisher</a>
          </td>
          </div>
        </div>
            </div>
            <div className="hrline"></div>
            <div className="Banner_BG Banner_BG_pub">
                <div className="Banner_padding_pub">


                    <div className="row pt-5">
                        <div className="col-sm-6 pr-5">
                            <p className="text-justify pb-3 p16">For publishers, AiPlex Ads provides access to millions of products and services across affiliate programs. We connect thousands of leading brands with publishers all over the world with a reliable, transparent and trusted tracking and
                                commission payment mechanism.
                            </p>
                            <img src="/assets/images/aiplex-ads-promotion.png" alt="promotions"  title="promotions" className="w-100"/>
                        </div>


                        <div className="col-sm-6 pl-5">
                            <div>
                                <h3 className="corporate h3f"><span className="first-letter">C</span>hoice</h3>
                                <p className="p16" >Thousands of advertisers to choose from and Hundreds being added weekly.

                                </p>
                                <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                            </div>
                            <div className="pt-3">
                                <h3 className="corporate h3f"><span className="first-letter">M</span>anagers</h3>
                                <p className="p16" >Managers dedicated to your campaigns to help with new revenue streams and better ROI.

                                </p>
                                <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                            </div>
                            <div className="pt-3">
                                <h3 className="corporate h3f"><span className="first-letter">T</span>echnology</h3>
                                <p className="p16" >Cross device, mobile, product level, and voucher code tracking. Easily integrated into any site as banner ads or text links.


                                </p>
                                <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                            </div>
                            <div className="pt-3">
                                <h3 className="corporate h3f"><span className="first-letter">D</span>ashboard</h3>
                                <p className="p16" >Track results reliably and quickly with a multitude of account management options.
                                </p>
                                <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                            </div>
                        </div>


                    </div>
                    <div className="row pt-3">
                        <div className="col-sm-12">
                            <h2 className="corporate  t40 "><span className="first-letter">P</span>romotions</h2>
                        </div>


                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-lg-5 col-xl-3 col-sm-5 boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OST <span className="first-letter">P</span>ER <span className="first-letter">C</span>LICK</h5>
                        </div>
                        <div className="col-lg-5 col-xl-3 col-sm-5 boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OST <span className="first-letter">P</span>ER <span className="first-letter">O</span>PEN</h5>
                        </div>
                        <div className="col-lg-5 col-xl-3 col-sm-5 boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OST <span className="first-letter">P</span>ER <span className="first-letter">I</span>MPRESSION</h5>
                        </div>
                        <div className="col-lg-5 col-xl-3 col-sm-5 boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OST <span className="first-letter">P</span>ER <span className="first-letter">S</span>ALE</h5>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-lg-5 col-xl-3 col-sm-5  boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OST <span className="first-letter">P</span>ER <span className="first-letter">L</span>EAD</h5>
                        </div>
                        <div className="col-lg-3 col-sm-5 boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OST <span className="first-letter">P</span>ER <span className="first-letter">I</span>NSTALL</h5>
                        </div>
                        <div className="col-lg-3 col-sm-5  boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OST <span className="first-letter">P</span>ER <span className="first-letter">V</span>ISIT</h5>
                        </div>
                        <div className="col-lg-3 col-sm-5  boxs">
                            <h5 className="corporate ctext">
                                <span className="first-letter">C</span>OMMUNICATION</h5>
                        </div>
                    </div>

                </div>
            </div>


            <div className="hrline"></div>
            <div className="Banner_BG Banner_BG_pub">
                <div className="Banner_padding">
                    <h1 className="text-center corporate  t40 "><span className="first-letter">M</span>ulti <span className="firt-letter">C</span>hannel <span className="first-letter">M</span>onetization <br/><span className="first-letter">S</span>upport for <span className="first-letter">P</span>ublishers</h1>
                    <div className="row pt-3">
                        <img src="/assets/images/aiplex-ads-monetization.png" alt="Multi Channel Monetization Support for Publishers"  title="Multi Channel Monetization Support for Publishers" className="w-100"/>
                    </div>
                    <div className="row pt-3">
                        <div className="col-sm-6 text-justify pr-5">
                            <p className="p16" style={{marginBottom: '16px !important'}}>
                                Are you a Publisher trying to monetize your content, website, or your social presence? Are you looking to partner with a network which can help you do that? AiPlex Ads is that partner!!! We are the monetization specialists; we understand your inventory
                                and can help you in every possible way to earn more revenues along with brand-building suggestions and a lot more. As a Publisher, you may have high quality traffic, but might be generating revenues through only one or two options,
                                either email or display. We at AiPlex Ads help you to realize the potential of your inventory and suggest numerous ways to monetize it.
                            </p>
                            <p className="p16">

                                Our easy-to-use platform is designed to make managing affiliate campaigns simple. With clear, consistent labels and layouts, a wide range of simple but effective tools and features, as well as a full reporting suite, AiPlex platform is designed to aid
                                any marketing operation; an individual blogger or influencer, or a full digital marketing team.


                            </p>
                        </div>
                        <div className="col-sm-6 text-justify pl-5">
                            <p className="p16" style={{marginBottom: '16px !important'}}>
                                Easily generate trackable links or images to add to your website, blog or content. Trackable links or images are simply generated through the AiPlex interface, and these can be used to add to your website, blog or social media accounts however you wish
                                to promote individual products, services or advertiser brands.</p>
                            <p className="p16">

                                We operate local publisher management and service teams in each market, as well as a global publisher team who are able to coordinate across multiple markets for international publishers. These teams are experts in their local market, and can offer insights
                                and support for all levels of publisher requests and queries. AiPlex also features dedicated experts across the fashion, telco, travel and influencer sectors to offer tailored support and recommendations to publishers within these
                                fields. Connecting businesses with customers in over 100 countries across verticals.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="consult">
                <div className=" bpadding2" style={{paddingBottom: '10px !important', paddingTop: '75px !important'}}>
                    <div className="row">
                        <div className="col-sm-7">
                            <h2><strong>Ready to get started?</strong></h2>
                            <h3>Learn how AiPlex Digital can solve <br/>your more complex needs</h3>
                        </div>
                        <div className="col-sm-3 float-bottom">
                            <a className="btn btn-primary1 " href="#contact" >Get In Touch</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hrline"></div>
            </div>
             )
    }
}
Publishers.propTypes = {
    value: PropTypes.object.isRequired
};
export default Publishers